
export default class AudioFileBaseModel {
    private _audioFile: File = null;
    private _audioFileReadPromise: Promise<string> = Promise.resolve(null);
    private _audioObjectUrl: string = '';
    get audioFile(): File {
        return this._audioFile;
    }
    base64File: string;
    set audioFile(file: File) {
        this.revokeAudioObjectUrl();
        this._audioFile = file;
        if (file == null) {
            this.base64File = null;
            this._audioFileReadPromise = Promise.resolve(null);
            return;
        }
        this._audioFileReadPromise = new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                this.base64File = reader.result.toString();
                resolve(this.base64File);
            };
            reader.onerror = () => {
                this.base64File = null;
                reject(reader.error);
            };
            reader.readAsDataURL(file);
        });
    }
    _audioUrl: string = '';
    get audioUrl(): string | Blob {
        if (this.audioFile) {
            if (!this._audioObjectUrl) {
                var blob = window.URL || window.webkitURL;
                this._audioObjectUrl = blob.createObjectURL(this.audioFile);
            }
            return this._audioObjectUrl;
        }
        return this._audioUrl;
    }
    set audioUrl(value: string | Blob) {
        this._audioUrl = (value || '').toString();
    }

    async ensureAudioFileReady(): Promise<void> {
        await this._audioFileReadPromise;
    }

    private revokeAudioObjectUrl() {
        if (!this._audioObjectUrl) {
            return;
        }
        var blob = window.URL || window.webkitURL;
        blob.revokeObjectURL(this._audioObjectUrl);
        this._audioObjectUrl = '';
    }
}
